import { library } from '@fortawesome/fontawesome-svg-core';
import { EllipsisHorizontalIcon as faEllipsis } from '@heroicons/react/24/solid';

import {
  faAngleLeft,
  faAngleRight,
  faArrowDown,
  faArrowRight,
  faArrowUp,
  faBars,
  faBell,
  faBook,
  faCalendar,
  faChartLine,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faChevronCircleLeft,
  faChevronCircleRight,
  faChevronDown as faChevronDownSolid,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp as faChevronUpSolid,
  faChevronUp,
  faClock,
  faCloudUploadAlt as faCloudUpload,
  faDesktop,
  faDownload,
  faEllipsisV,
  faEnvelopeOpen,
  faExclamationCircle,
  faExclamationTriangle,
  faFileAlt,
  faFilePowerpoint,
  faFilter,
  faGraduationCap,
  faHandHoldingUsd as faUsdCircle,
  faLaptop,
  faLifeRing,
  faMinus,
  faMobileAlt,
  faNewspaper,
  faPlay,
  faPlus,
  faPrint,
  faSearch,
  faShare,
  faTags,
  faTimes,
  faTrash,
  faUpload,
  faUserCircle,
  faUserPlus,
  faUsers,
  faVolumeUp,
  faWalking,
} from '@fortawesome/free-solid-svg-icons';

import {
  faEdit,
  faHandshake,
  faFilePdf,
  faEnvelope,
  faSquare,
  faQuestionCircle,
} from '@fortawesome/free-regular-svg-icons';

library.add(
  faAngleLeft,
  faAngleRight,
  faArrowDown,
  faArrowRight,
  faArrowUp,
  faBars,
  faBell,
  faBook,
  faCalendar,
  faChartLine,
  faCheck,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faChevronCircleLeft,
  faChevronCircleRight,
  faChevronDown,
  faChevronDownSolid,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronUpSolid,
  faClock,
  faClock,
  faCloudUpload,
  faDesktop,
  faDownload,
  faEllipsisV,
  faEnvelope,
  faExclamationTriangle,
  faFileAlt,
  faFilePdf,
  faFilePowerpoint,
  faFilePowerpoint,
  faFilter,
  faGraduationCap,
  faEdit,
  faHandshake,
  faLaptop,
  faLifeRing,
  faMinus,
  faMobileAlt,
  faNewspaper,
  faPlay,
  faPlus,
  faPrint,
  faQuestionCircle,
  faSearch,
  faShare,
  faTags,
  faTimes,
  faTrash,
  faUpload,
  faUserCircle,
  faUserPlus,
  faUsers,
  faVolumeUp,
  faWalking
);

export {
  faAngleLeft,
  faAngleRight,
  faArrowDown,
  faArrowRight,
  faArrowUp,
  faBars,
  faBell,
  faBook,
  faCalendar,
  faChartLine,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faChevronCircleLeft,
  faChevronCircleRight,
  faChevronDown,
  faChevronDownSolid,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronUpSolid,
  faClock,
  faCloudUpload,
  faDesktop,
  faDownload,
  faEllipsis,
  faEllipsisV,
  faEnvelope,
  faEnvelopeOpen,
  faExclamationCircle,
  faExclamationTriangle,
  faFileAlt,
  faFilePdf,
  faFilePowerpoint,
  faFilter,
  faGraduationCap,
  faEdit,
  faHandshake,
  faLaptop,
  faLifeRing,
  faMinus,
  faMobileAlt,
  faNewspaper,
  faPlay,
  faPlus,
  faPrint,
  faSearch,
  faShare,
  faSquare,
  faQuestionCircle,
  faTags,
  faTimes,
  faTrash,
  faUpload,
  faUsdCircle,
  faUserCircle,
  faUserPlus,
  faUsers,
  faVolumeUp,
  faWalking,
};
